/**
 * angular imports
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarComponent } from './calendar/calendar.component';

/**
 * prime ng importsuploadFileOnKeeper
 */
import { CalendarModule } from 'primeng/calendar';



@NgModule({
  declarations: [
    CalendarComponent
  ],
  imports: [
    CommonModule,
    CalendarModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    CalendarComponent
  ]
})
export class datePickerModule { }
